/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardItemView',["LoyaltyCardItemData","LoyaltyCardItemSrv","LoyaltyCardItem","SaleData","$filter","$timeout","CurrencyManager","NumberSeparatorType","gettextCatalog",
        function (LoyaltyCardItemData,LoyaltyCardItemSrv,LoyaltyCardItem,SaleData,$filter,$timeout,CurrencyManager,NumberSeparatorType,gettextCatalog)
        {

        var LoyaltyCardItemView = function (loyaltyCardItem,lIndex,billPosition,saleView,posView)
        {
            this.lIndex = lIndex;
            this.posView = (saleView) ? saleView.posView : posView;
            this.saleView = saleView; // creation sale
            this.label = "";
            this.type = null; // nbSales / pts / subs
            this.itemType = null; // nbSales / pts / subs
            this.color = "";
            this.ptsByCa = 0;
            this.ptsBySale = 0;
            this.monthValidity = 0;
            this.validityExtend = true;
            this.validityDate = null;
            this.updateValidityDateString();
            this.alertExp = 0;
            this.description= "";
            this.price = 0;
            this.priceHT = 0;
            this.vat = null;
            this.vatCode = null;
            this.priceInput = $filter("currencyFormatFilter")(0);
            this.originalPrice = 0;
            this.originalPriceInput = "";
            this.originalPriceSelect = "";
            this.discountPercent = 0;
            this.hrView = null;
            this.loyaltyCardView = null;
            this.customerView = null;
            this.pts = 0;
            this.goalPts = null;
            this.goalType = null;// special, discountValue,discountPercent
            this.goalAmount = null;
            this.goalText = null;
            this.isUsed = false;
            this.billPosition =billPosition; // view
            this.validityDatePickerOpened = false;
            this.linkedSalesView = []; //view
            this.discountTypeText = gettextCatalog.getString("Remise de");
            this.nextRewardsText = gettextCatalog.getString("à la prochaine récompense");
            this.discountTypeSymbol = "%";
            if (loyaltyCardItem!==undefined && loyaltyCardItem!=null)
                this.loadDataFrom(loyaltyCardItem);
        };
        LoyaltyCardItemView.prototype.getModel = function()
        {
            if (this.lIndex!=-1)
            {
                return LoyaltyCardItemData.getByIndex(this.lIndex);
            }
            return null;
        };
        LoyaltyCardItemView.prototype.loadDataFrom = function(loyaltyCardItem)
        {
            //Assume here than the object in parameter contains only id (must load them)
            this.label = loyaltyCardItem.label;
            this.color = loyaltyCardItem.color;
            this.type = loyaltyCardItem.type;
            this.itemType = loyaltyCardItem.itemType;
            this.ptsByCa = loyaltyCardItem.ptsByCa;
            this.ptsBySale = loyaltyCardItem.ptsBySale;
            this.pts = loyaltyCardItem.pts;
            this.goalPts = loyaltyCardItem.goalPts;
            this.goalType = loyaltyCardItem.goalType;
            this.goalAmount = loyaltyCardItem.goalAmount;
            this.goalText = loyaltyCardItem.goalText;
            this.monthValidity = loyaltyCardItem.monthValidity;
            this.validityExtend = loyaltyCardItem.validityExtend;
            this.alertExp = loyaltyCardItem.alertExp;
            if (loyaltyCardItem.validityDate)
            {
                this.validityDate = new Date(loyaltyCardItem.validityDate);
                this.validityDateString = $filter('date')(loyaltyCardItem.validityDate,'shortDate');
            }
            this.description= loyaltyCardItem.description;
            this.price= loyaltyCardItem.price;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            if (loyaltyCardItem.vatCode)
            {
                this.vat= loyaltyCardItem.vat;
                this.vatCode= loyaltyCardItem.vatCode;
            }
            else
            {
                if (this.saleView)
                {
                    this.vat = this.saleView.vat;
                    this.vatCode = this.saleView.vatCode;
                }
            }
            this.vat= loyaltyCardItem.vat;
            this.vatCode= loyaltyCardItem.vatCode;
            this.originalPrice= loyaltyCardItem.originalPrice;
            this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
            this.discountPercent = loyaltyCardItem.discountPercent;
            this.updatePriceHT();

            if (loyaltyCardItem.loyaltyCard && this.posView)
                this.loyaltyCardView =  this.posView.domainView.getLoyaltyCardView(loyaltyCardItem.loyaltyCard);
            if (loyaltyCardItem.humanResource && this.posView)
                this.hrView = this.posView.domainView.getHrView(loyaltyCardItem.humanResource);

            this.isUsed = loyaltyCardItem.isUsed;

        };
        LoyaltyCardItemView.prototype.setLoyaltyCard = function(loyaltyCardView,isOnInternet)
        {
            this.loyaltyCardView = loyaltyCardView;
            if (loyaltyCardView!=null)
            {
                if(this.posView && this.posView.domainView)
                {
                    var vatView = this.posView.domainView.getDefaultVatView();
                    if (vatView) {
                        this.vat = vatView.tax;
                        this.vatCode = vatView.code;
                    }
                }
                this.label = loyaltyCardView.label;
                if (loyaltyCardView.styleView)
                    this.color = loyaltyCardView.styleView.background;
                this.type = loyaltyCardView.type;
                this.itemType = loyaltyCardView.itemType;
                this.monthValidity = loyaltyCardView.monthValidity;
                this.validityExtend = loyaltyCardView.validityExtend;
                this.alertExp = loyaltyCardView.alertExp;
                this.originalPrice = loyaltyCardView.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                this.goalPts = loyaltyCardView.goalPts;
                this.goalType = loyaltyCardView.goalType;
                this.goalAmount = loyaltyCardView.goalAmount;
                this.goalText = loyaltyCardView.goalText;
                this.validityDate = new Date();
                this.validityDate.setHours(0,0,0,0);
                this.validityDate.setMonth(this.validityDate.getMonth() + this.monthValidity);
                if (isOnInternet!==undefined && isOnInternet && loyaltyCardView.hasInternetPrice) {
                    this.discountPercent = loyaltyCardView.internetDiscountPercent;
                }
                if ("pts" === loyaltyCardView.type) {
                    this.ptsByCa = 1;
                    this.ptsBySale = 0;
                } else if ("nbSales" === loyaltyCardView.type) {
                    this.ptsByCa = 0;
                    this.ptsBySale = 1;
                } else {
                    this.ptsByCa = 0;
                    this.ptsBySale = 0;
                }
                this.updatePrice();

            }
        };
        LoyaltyCardItemView.prototype.updatePrice = function()
        {
            var oriPrice = this.originalPrice;
            var discount = 0;
            var discountPercent =this.discountPercent;
            if (this.discountPercent && typeof this.discountPercent ==='string')
            {
                discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                discountPercent = parseFloat(discountPercent);
            }
            if (discountPercent!=0)
                discount = Math.round((discountPercent *  oriPrice / 100)*100)/100;

            if ((oriPrice-discount)!=this.price)
            {
                this.price = (oriPrice-discount);
                this.priceInput = $filter('currencyFormatFilter')(this.price);
                this.updatePriceHT();
                if(this.saleView)
                {
                    this.saleView.resetPayments();
                    this.saleView.calculateSaleFields();
                }
            }
            this.saleView.checkForInvalidAmounts();
        };
        LoyaltyCardItemView.prototype.updatePriceHT = function(){
            if(this.saleView)
                this.priceHT = Math.round((100/(100+this.saleView.vat) * this.price)*100)/100;
        };
        LoyaltyCardItemView.prototype.updateOriginalPriceInputArrow = function(number)
        {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput!=null && typeof this.originalPriceInput ==='string') {
                var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                var originalPrice = parseFloat(originalPriceStr);
                if(originalPrice !== "NaN")
                    originalPrice+= number;

                this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
                this.originalPrice = originalPrice;
                this.updatePrice();
            }
        };

        LoyaltyCardItemView.prototype.onOriginalPriceInputChange = function() {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput!=null && typeof this.originalPriceInput ==='string') {
                let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                let originalPrice = parseFloat(originalPriceStr);
                if (originalPrice !== "NaN") {
                    this.originalPrice = originalPrice;
                } else {
                    this.originalPrice = null;
                }
                this.updatePrice();
            }
        };

        LoyaltyCardItemView.prototype.increaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if ((step + this.discountPercent) > 100)
                    this.discountPercent = 100;
                else
                    this.discountPercent += step;
                this.updatePrice();
            }

        };
        LoyaltyCardItemView.prototype.decreaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if (this.discountPercent-step<0)
                    this.discountPercent = 0;
                else
                    this.discountPercent-=step;
                this.updatePrice();
            }

        };
        LoyaltyCardItemView.prototype.updatePercentOnPriceChange = function()
        {
            this.discountPercent =  Math.round(100*(100- 100* this.price/this.originalPrice))/100;
            this.updatePriceHT();
            if(this.saleView) {
                this.saleView.resetPayments();
                this.saleView.calculateSaleFields();
            }
        };
        LoyaltyCardItemView.prototype.copyDataTo = function(loyaltyCardItem)
        {
            //Assume here than the object in parameter contains only id (must load them)
            loyaltyCardItem.label = this.label;
            loyaltyCardItem.color = this.color;
            loyaltyCardItem.type = this.type;
            loyaltyCardItem.itemType = this.itemType;
            loyaltyCardItem.ptsByCa = this.ptsByCa;
            loyaltyCardItem.ptsBySale = this.ptsBySale;
            loyaltyCardItem.pts = this.pts;
            loyaltyCardItem.monthValidity = this.monthValidity;
            loyaltyCardItem.validityExtend = this.validityExtend;
            loyaltyCardItem.validityDate = this.validityDate;
            loyaltyCardItem.alertExp = this.alertExp;
            loyaltyCardItem.description = this.description;
            loyaltyCardItem.price= this.price;
            loyaltyCardItem.vat = this.vat;
            loyaltyCardItem.vatCode= this.vatCode;
            loyaltyCardItem.originalPrice= this.originalPrice;
            loyaltyCardItem.goalPts = this.goalPts;
            loyaltyCardItem.goalType = this.goalType;
            loyaltyCardItem.goalAmount = this.goalAmount;
            loyaltyCardItem.goalText = this.goalText;
            loyaltyCardItem.isUsed = this.isUsed;
            if (this.discountPercent && typeof this.discountPercent ==='string')
            {
                loyaltyCardItem.discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                loyaltyCardItem.discountPercent = parseFloat(loyaltyCardItem.discountPercent);
            }
            else
                loyaltyCardItem.discountPercent= this.discountPercent;

            if (this.saleView)
            {
                var newSale = this.saleView.getModel();
                if (loyaltyCardItem.sale && newSale!==loyaltyCardItem.sale)//remove
                    loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
                if (newSale)//Force add because removed by sale.updateModel
                    newSale.addLoyaltyCardItem(loyaltyCardItem);
                this.customerView = this.saleView.customerView;
            }

            if (this.loyaltyCardView)
                loyaltyCardItem.loyaltyCard = this.loyaltyCardView.getModel();

            if (this.customerView)
                loyaltyCardItem.customer = this.customerView.getModel();

            if (this.hrView)
                loyaltyCardItem.humanResource = this.hrView.getModel();


        };
        LoyaltyCardItemView.prototype.toggleUsage = function(callbackFunction)
        {
            this.isUsed = !this.isUsed;
            this.updateModel(true, callbackFunction);
            if (this.customerView)
                this.customerView.initHistoryView();
        };

        LoyaltyCardItemView.prototype.updateModel = function(save, callbackFunction)
        {
            var loyaltyCardItem = this.getModel();
            if (loyaltyCardItem==null)
            {
                loyaltyCardItem = new LoyaltyCardItem();
                this.lIndex = LoyaltyCardItemData.getIndexOf(loyaltyCardItem);
            }

            this.copyDataTo(loyaltyCardItem);
            if (save) {
                LoyaltyCardItemSrv.save(loyaltyCardItem, callbackFunction);
            }
        };

        LoyaltyCardItemView.prototype.removeModel = function()
        {
            var loyaltyCardItem = this.getModel();
            if (loyaltyCardItem!=null)
            {
                LoyaltyCardItemSrv.remove(loyaltyCardItem);
            }
        };

        LoyaltyCardItemView.prototype.reloadModel = function()
        {
            var loyaltyCardItem = this.getModel();
            if (loyaltyCardItem==null)
            {

            }
            else
            {
                this.loadDataFrom(loyaltyCardItem);
            }

        };

        LoyaltyCardItemView.prototype.restoreModel = function()
        {   //undeleted
            var loyaltyCardItem = this.getModel();
            if (loyaltyCardItem)
            {
                LoyaltyCardItemSrv.restore(loyaltyCardItem);
            }

        } ;

        LoyaltyCardItemView.prototype.updateCanSave = function()
        {
            if
            (
                (this.label && this.label!="") //titre
                && (this.price!=null && this.price>=0 )
            )
            { this.canSave = true; }
            else
            { this.canSave = false;}
        };

        LoyaltyCardItemView.prototype.onValidityDateStringUpdate = function()//
        {
            if (this.validityDateString && this.validityDateString.length==10)
            {
                var year = this.validityDateString.substring(6,10);
                var month = this.validityDateString.substring(3,5);
                var day = this.validityDateString.substring(0,2);
                this.validityDate = new Date(year + '/' + month + '/' + day);
                this.validityDate.setHours(0,0,0,0);
            }
            else
                this.validityDate = null;
        };

        LoyaltyCardItemView.prototype.updateValidityDateString = function()
        {
            if (this.validityDate)
                this.validityDateString = $filter('date')(this.validityDate,'shortDate');
        };

        LoyaltyCardItemView.prototype.getValidityDateFromNow = function()
        {

            if (this.validityExtend)
            {
                var newV = new Date();
                if (this.validityDate)
                    this.validityDate.setHours(0,0,0,0);
                newV.setMonth(newV.getMonth() + this.monthValidity);
                return newV;
            }
            else
                return this.validityDate;
        };

        LoyaltyCardItemView.prototype.onValidityDateStringKeyup = function(event)//
        {
            if (this.validityDateString)
                if (!(event && (event.which==8 || event.which==46 ))) //if key delete detected : clear supplier
                {
                    if ((this.validityDateString.length==4||this.validityDateString.length==7) && (this.validityDateString[this.validityDateString.length-1]=='/'))
                        this.validityDateString = this.validityDateString.substr(0,this.validityDateString.length-2);

                    if (this.validityDateString.length==2||this.validityDateString.length==5)
                        this.validityDateString+="/";
                }
        };

        LoyaltyCardItemView.prototype.displayLoyaltyCardItemDatePickerF = function()
        {
            var loyaltycarditemView = this;
            $timeout(function(){loyaltycarditemView.validityDatePickerOpened = true;})
        };

        LoyaltyCardItemView.prototype.setHrView = function(hrView)
        {
            this.hrView = hrView;
        };

        LoyaltyCardItemView.prototype.getClone = function(saleView)
        {
            var loyaltyCardItemView = new LoyaltyCardItemView(null,-1,this.billPosition,saleView);
            loyaltyCardItemView.vatCode= this.vatCode;
            loyaltyCardItemView.vat= this.vat;
            loyaltyCardItemView.label = this.label;
            loyaltyCardItemView.color = this.color;
            loyaltyCardItemView.type = this.type;
            loyaltyCardItemView.itemType = this.itemType;
            loyaltyCardItemView.ptsByCa = this.ptsByCa;
            loyaltyCardItemView.ptsBySale = this.ptsBySale;
            loyaltyCardItemView.pts = this.pts;
            loyaltyCardItemView.monthValidity = this.monthValidity;
            loyaltyCardItemView.validityExtend = this.validityExtend;
            loyaltyCardItemView.validityDate = this.validityDate;
            loyaltyCardItemView.alertExp = this.alertExp;
            loyaltyCardItemView.description = this.description;
            loyaltyCardItemView.price= this.price;
            loyaltyCardItemView.originalPrice= this.originalPrice;
            loyaltyCardItemView.goalPts = this.goalPts;
            loyaltyCardItemView.goalType = this.goalType;
            loyaltyCardItemView.goalAmount = this.goalAmount;
            loyaltyCardItemView.goalText = this.goalText;
            loyaltyCardItemView.isUsed = this.isUsed;
            loyaltyCardItemView.discountPercent = this.discountPercent;
            loyaltyCardItemView.loyaltyCardView = this.loyaltyCardView;
            loyaltyCardItemView.customerView = this.customerView;
            loyaltyCardItemView.hrView = this.hrView;
            return loyaltyCardItemView;
        };

        LoyaltyCardItemView.prototype.updateLinkedSalesView = function() {
            var loyaltyCardItem = this.getModel();
            this.linkedSalesView = [];
            if (loyaltyCardItem)
            {
                var balance = 0;
                this.totalLoyaltyPtsWon = 0;
                this.totalLoyaltyPtsUse = 0;
                var linkedSales = [];

                for (var i=0;i<SaleData.indexSales.length;i++)
                    if(loyaltyCardItem===SaleData.indexSales[i].loyaltyCardItem && SaleData.indexSales[i].status=="sold")
                        linkedSales.push(SaleData.indexSales[i]);
                linkedSales = $filter('orderBy')(linkedSales, 'saleNumber');//execute angular filter
                for (var i=0;i<linkedSales.length;i++)
                    {
                        balance +=linkedSales[i].loyaltyPts;
                        var linkedSaleView = {
                            saleNumber : linkedSales[i].saleNumber,
                            discountPercent : linkedSales[i].discountPercent,
                            loyaltyPtsBalance : balance,
                            goalAmount : linkedSales[i].loyaltyCardItem.goalAmount,
                            goalType : linkedSales[i].loyaltyCardItem.goalType,
                            goalText : linkedSales[i].loyaltyCardItem.goalText,
                            dayView:{date:linkedSales[i].day ? linkedSales[i].day.getDate() : null}};

                        if (linkedSales[i].loyaltyPts>=0)
                        {
                            linkedSaleView.loyaltyPtsWon = linkedSales[i].loyaltyPts;
                            linkedSaleView.loyaltyPtsUse =0;
                            this.totalLoyaltyPtsWon += linkedSales[i].loyaltyPts;
                        }
                        else
                        {
                            linkedSaleView.loyaltyPtsUse = linkedSales[i].loyaltyPts;
                            linkedSaleView.loyaltyPtsWon =0;
                            this.totalLoyaltyPtsUse += linkedSales[i].loyaltyPts;
                        }
                        this.linkedSalesView.push(linkedSaleView);

                    }
            }

        };

        LoyaltyCardItemView.prototype.getDiscountToolTipContent = function()
        {
            if (this.goalType === "discountValue")
                this.discountTypeSymbol = CurrencyManager.getCurrencySymbol();
            else if (this.goalType === "special")
                return this.goalText;
            return this.discountTypeText + " " + this.goalAmount + " " + this.discountTypeSymbol + " " + this.nextRewardsText;
        };

        LoyaltyCardItemView.prototype.getGoalPoints = function () {
            if (this.nbLoyaltyCardGoal() > 0)
                return this.goalPts;
            else
                return 0;
        };

        LoyaltyCardItemView.prototype.getGoalAmount = function(nbLoyaltyCardGoal)
        {
            if (this.goalType === "discountValue")
                return  this.goalAmount*nbLoyaltyCardGoal;
            else
                return  this.goalAmount;
        };

        LoyaltyCardItemView.prototype.computeLoyaltyDiscount = function (loyaltyPoints) {
            if (this.goalType === "discountValue")
                return Math.abs(loyaltyPoints / this.goalPts) * this.goalAmount;
            else
                return this.goalAmount;
        };

        LoyaltyCardItemView.prototype.getNextGoalAmount = function(newPts)
        {
            if (this.goalType === "discountValue"){
                if(Math.floor((this.pts + newPts)/this.goalPts) >=1){
                    return this.goalAmount;//add next points
                }
                else {
                    return 0;
                }
            }
            else
                return this.goalAmount;
        };

        LoyaltyCardItemView.prototype.computeGoalAmountNextSale = function()
        {
            return this.pts >= this.goalPts ? this.goalAmount : 0;
        };

        LoyaltyCardItemView.prototype.nbLoyaltyCardGoal = function (salePrice, salePoints, hasLoyaltyCardInShoppingCart) {
            let nbLoyaltyCardGoal = 0;
            if (this.type === "subs") {
                nbLoyaltyCardGoal = hasLoyaltyCardInShoppingCart ? 0 : 1;
            } else {
                if (this.goalType === "discountValue" && salePrice !== undefined) // limited by salePrice if salePrice==0 || salePrice defined
                {
                    let points = salePoints;
                    if (!points) {
                        points = this.pts;
                    }
                    if (points > 0 && this.goalPts > 0) {
                        if(points >= this.goalPts && (salePrice - this.getGoalAmount(nbLoyaltyCardGoal + 1)) >= 0) {
                            nbLoyaltyCardGoal = 1;
                        }
                    }
                } else // discountPercent OR Next possible
                {
                    nbLoyaltyCardGoal = Math.floor(this.pts / this.goalPts) >=1 ? 1: 0;
                }
            }
            return nbLoyaltyCardGoal;
        };

        return LoyaltyCardItemView;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/views/LoyaltyCardItemView.js